import React, {useState} from 'react'
import {withRouter} from 'react-router-dom';
import './TopNav.scss'
import {MDBModal, MDBModalBody} from "mdbreact";
import AddMoney from "../../pages/UserWallet/AddMoney";
import WithdrawMoney from "../../pages/UserWallet/WithdrawMoney";
import CashDetail from "../../pages/UserWallet/CashDetail";
import {assetUrl} from "../../serviceApi";
import Login from "../../pages/Login/Login";
import {connect} from "react-redux";

const backArrow = assetUrl+"images/icon_black-arrow-left.svg";
const purse = assetUrl+"images/icon_wallet.svg";
const bell = assetUrl+"images/top-header-bell.svg";
const Emptybell = assetUrl+"images/Notifications-bell-empty-black.svg";


const TopNavSubpage = (props) => {
    const {heading, wallet, notify} = props
    const [notification, setNotification] = useState([]);
    const [currentModal,setCurrentModal] = useState("");
    const [login_modal, setLoginModal] = useState(false);

    const styleTopNav_Sub = "nav-sub-"
    let path = props.history
    const backButtonHandler = () => {
        path.goBack()

    }
    const setActiveModal = (args) => {
      setCurrentModal(args)
    }
    const checkUserLoggedIn = (action) => {
        if(props.logged_in === false){
            openLoginModal();
        } else if(action === "wallet") {
            setCurrentModal("cash");
        } else if(action === "notification") {
            props.history.push("/notification")
        }
    }
    const openLoginModal = () => {
        setLoginModal(true);
    }
    const closeLoginModal = () => {
        setLoginModal(false);
    }
    const completeLogin = () => {
        closeLoginModal();
        window.location.reload();
        // this.getWalletData();
    }
    return (
        <>
                <div
                    className={styleTopNav_Sub + 'navWrap d-flex justify-content-between align-items-center '}>
                    <div className={'d-flex'}>
                        <img alt={'alt'} src={backArrow} onClick={backButtonHandler} />
                        <p className={styleTopNav_Sub + "nav-text my-0"}>{heading}</p>
                    </div>
                    <div className={'d-flex '}>
                        {wallet ? <img src={purse} alt={'wallet'} className={" mr-3"}
                                       onClick={() => checkUserLoggedIn("wallet")}/> : null}
                        {notify ? <img src={notification.length >0 ?bell:Emptybell} alt={'notify'} className={" mx-0"}
                                       onClick={() => checkUserLoggedIn("notification")}/> : null}
                    </div>
                    <MDBModal fullHeight={false} position="bottom" overflowScroll={true} inline={false}
                              noClickableBodyWithoutBackdrop={false} isOpen={currentModal !== ""}>
                        <MDBModalBody>
                            {
                                currentModal === "add" ?
                                    <AddMoney
                                        setActiveModal={(args) => setActiveModal(args)}
                                        user_details={props.user_details}
                                    /> :
                                    currentModal === "withdraw" ?
                                        <WithdrawMoney
                                            setActiveModal={(args) => setActiveModal(args)}
                                            user_details={props.user_details}
                                        /> :
                                        currentModal === "cash" ?
                                            <CashDetail setActiveModal={(args) => {

                                                setActiveModal(args)
                                            }}/> :
                                            null
                            }


                        </MDBModalBody>
                    </MDBModal>
                </div>
                <Login isOpen={login_modal}
                       closeModal={closeLoginModal}
                       completeLogin={completeLogin}
                />
            </>
    )
}
const mapStateToProps = state => ({
    logged_in: state.UserReducer.logged_in
});

export default connect(mapStateToProps)(withRouter(TopNavSubpage))
